export const global = {
  buildAt: new Date(),
  api: process.env.REACT_APP_API_URL,
  token: process.env.REACT_APP_TOKEN,
  avatar_uri: process.env.REACT_APP_AVATAR_PATH,
};
